import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            reference: '',
            contractId: 0,
            contractItemId: 0,
            systemId: 0,
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/DemandBilling.js